import React, { useState } from 'react';

/**
 * La sezione a fisarmonica della schermata di una procedura.
 *
 * PERCHE' STA IN UN FILE SUO
 * La usano la procedura e le schede cliniche che ci compaiono dentro. Con
 * il componente dentro ProceduraDettaglio le due si importavano a vicenda,
 * e un import circolare funziona finche' non smette - di solito il giorno
 * in cui qualcuno sposta una riga. Un riquadro che si apre e si chiude
 * deve comportarsi allo stesso modo ovunque, e questo e' il modo di
 * garantirlo: uno solo.
 *
 * CHIUSA DI PARTENZA, e non e' un dettaglio: la colonna di una procedura
 * ha una dozzina di riquadri, e aperti tutti insieme costringono a
 * scorrere per trovare quello che serve. Si apre quello che si usa.
 */
export const Sezione = ({ icon, title, right, children, defaultOpen = false, placeholder = false }) => {
    const [open, setOpen] = useState(defaultOpen);
    return (
        <div className={`pd-sez ${placeholder ? 'pd-sez--ph' : ''}`}>
            <div className="pd-sez-head" onClick={() => setOpen((o) => !o)}>
                <span className="pd-sez-title"><span className="pd-sez-ico">{icon}</span>{title}</span>
                {right && <span className="pd-sez-right" onClick={(e) => e.stopPropagation()}>{right}</span>}
                <span className="pd-sez-chev">{open ? '▾' : '▸'}</span>
            </div>
            {open && <div className="pd-sez-body">{children}</div>}
        </div>
    );
};

export default Sezione;
